import { template as template_cafa6bbdafcf42188c7d01edbff8216f } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/html';
export default RouteTemplate(template_cafa6bbdafcf42188c7d01edbff8216f(`
  <@model.Component @format={{@model.format}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
